import { cx } from "@/utils";
import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";
import Badge from "@components/Badge";

import styles from "./StaffBadge.module.css";

const StaffBadge: React.FunctionComponent<{ className?: string }> = ({
  className,
}) => (
  <AccessControl level={ACCESS_LEVELS.STAFF}>
    <Badge variant="success" className={cx(styles.root, className)}>
      Staff
    </Badge>
  </AccessControl>
);

export default StaffBadge;
